var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-content-board"},_vm._l((_vm.routerViews),function(routerViewName,index){return _c('div',{key:'router-view-' + index,staticClass:"board-single"},[_c('router-view',{attrs:{"name":routerViewName}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }